import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=ed002f98&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Category.vue?vue&type=style&index=0&id=ed002f98&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Category.vue?vue&type=style&index=1&id=ed002f98&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ed002f98",
  "4eeb9281"
  
)

export default component.exports